// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Menu = require("../../common/Components/Menu.bs.js");
let Avatar = require("../../common/Components/Avatar.bs.js");
let IconV5 = require("../../common/Components/IconV5.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let TailwindMerge = require("tailwind-merge");
let React = require("linkifyjs/react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../../common/Components/AgentProfilePhoto.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsSection__MessageFiles = require("../../common/Components/ConversationsSection__MessageFiles.bs.js");
let ConversationsSection__MessageImages = require("../../common/Components/ConversationsSection__MessageImages.bs.js");
let ConversationPageConversationMessagesMessage_message_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessage_message_graphql.bs.js");
let ConversationPageConversationMessagesMessage_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessage_conversation_graphql.bs.js");
let ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.bs.js");

function ConversationPageConversationMessagesMessage$ChatAvatar(props) {
  let overlayIcon = props.overlayIcon;
  let name = props.name;
  let src = props.src;
  return JsxRuntime.jsx("div", {
    children: overlayIcon !== undefined ? JsxRuntime.jsxs("span", {
        children: [
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: overlayIcon,
              size: 20,
              className: props.iconClassName
            }),
            className: "absolute right-[-8%] top-[58%] opacity-40"
          }),
          JsxRuntime.jsx(Avatar.make, {
            name: name,
            src: src,
            size: 1
          })
        ],
        className: "relative inline-block"
      }) : JsxRuntime.jsx(Avatar.make, {
        name: name,
        src: src,
        size: 1
      }),
    className: "mr-2.5"
  });
}

let ChatAvatar = {
  make: ConversationPageConversationMessagesMessage$ChatAvatar
};

let convertFragment = ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageConversationMessagesMessage$ChatParticipantMenu(props) {
  let agent = RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, props.agent);
  let firstName = agent.firstName;
  if (firstName === undefined) {
    return null;
  }
  let phone = agent.phone;
  return JsxRuntime.jsxs(Menu.Menu.make, {
    button: props.button,
    children: [
      JsxRuntime.jsx(Menu.MenuItem.make, {
        href: "/agents/" + agent.id,
        children: "View profile"
      }),
      phone !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Menu.MenuItem.make, {
              href: `tel:` + phone,
              children: `Call`
            }),
            JsxRuntime.jsx(Menu.MenuItem.make, {
              href: `sms:` + phone,
              children: `Send a text`
            })
          ]
        }) : JsxRuntime.jsx(Menu.MenuItem.make, {
          onAction: prim => {},
          isDisabled: true,
          children: `No phone number for ` + firstName
        })
    ]
  });
}

let ChatParticipantMenu = {
  AgentFragment: AgentFragment,
  make: ConversationPageConversationMessagesMessage$ChatParticipantMenu
};

let convertFragment$1 = ConversationPageConversationMessagesMessage_message_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

let MessageFragment_incomingMessageStatusState_decode = ConversationPageConversationMessagesMessage_message_graphql.Utils.incomingMessageStatusState_decode;

let MessageFragment_incomingMessageStatusState_fromString = ConversationPageConversationMessagesMessage_message_graphql.Utils.incomingMessageStatusState_fromString;

let MessageFragment_membershipStatusV5_decode = ConversationPageConversationMessagesMessage_message_graphql.Utils.membershipStatusV5_decode;

let MessageFragment_membershipStatusV5_fromString = ConversationPageConversationMessagesMessage_message_graphql.Utils.membershipStatusV5_fromString;

let MessageFragment = {
  incomingMessageStatusState_decode: MessageFragment_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: MessageFragment_incomingMessageStatusState_fromString,
  membershipStatusV5_decode: MessageFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: MessageFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = ConversationPageConversationMessagesMessage_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

let ConversationFragment_conversationVisibilityV5_decode = ConversationPageConversationMessagesMessage_conversation_graphql.Utils.conversationVisibilityV5_decode;

let ConversationFragment_conversationVisibilityV5_fromString = ConversationPageConversationMessagesMessage_conversation_graphql.Utils.conversationVisibilityV5_fromString;

let ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageConversationMessagesMessage(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, props.conversation);
  let message = RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, props.message);
  let agent = UserSession.useAgentInfo();
  let match = message.from;
  let messageIsFromLoggedInUser = match !== undefined && match.__typename === "Agent" ? match.id === agent.id : false;
  let tmp;
  if (messageIsFromLoggedInUser) {
    tmp = null;
  } else {
    let match$1 = message.from;
    let tmp$1;
    if (messageIsFromLoggedInUser) {
      tmp$1 = null;
    } else {
      let exit = 0;
      if (match$1 !== undefined && match$1.__typename === "Agent") {
        let match$2 = match$1.membershipStatus;
        let exit$1 = 0;
        if (match$2 === "TERMINATED") {
          tmp$1 = JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatAvatar, {
            src: AvatarSrcUrl.place_holder,
            name: match$1.displayName,
            overlayIcon: "unavailable",
            iconClassName: "text-tan-error-500"
          });
        } else {
          exit$1 = 2;
        }
        if (exit$1 === 2) {
          let fragmentRefs = match$1.fragmentRefs;
          tmp$1 = JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatParticipantMenu, {
            agent: fragmentRefs,
            button: JsxRuntime.jsx(ButtonsV5.Button.make, {
              className: "!p-0 !border-none hover:cursor-pointer",
              children: JsxRuntime.jsx(AgentProfilePhoto.make, {
                profilePhoto: fragmentRefs,
                className: "h-10 w-10"
              })
            })
          });
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$1 = JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatAvatar, {
          src: AvatarSrcUrl.place_holder,
          name: "A TAN User"
        });
      }
    }
    tmp = JsxRuntime.jsx("div", {
      children: tmp$1,
      className: "shrink-0"
    });
  }
  let tmp$2;
  if (messageIsFromLoggedInUser) {
    tmp$2 = null;
  } else {
    let match$3 = message.from;
    let tmp$3;
    tmp$3 = match$3 !== undefined && match$3.__typename === "Agent" ? JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatParticipantMenu, {
        agent: match$3.fragmentRefs,
        button: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
          children: match$3.displayName
        })
      }) : "A TAN User";
    tmp$2 = JsxRuntime.jsx("div", {
      children: tmp$3,
      className: "mb-1"
    });
  }
  let text = message.text;
  let tmp$4;
  if (text !== undefined && text !== "") {
    let match$4 = conversation.visibility;
    let tmp$5;
    tmp$5 = messageIsFromLoggedInUser ? (
        match$4 !== undefined ? (
            match$4 === "PRIVATE" || match$4 === "PUBLIC" ? (
                match$4 === "PRIVATE" ? "bg-sky-100" : "bg-green-100"
              ) : "bg-gray-100"
          ) : "bg-sky-100"
      ) : "bg-gray-100";
    tmp$4 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(React, {
          children: text
        }),
        className: "text-gray-900"
      }),
      className: TailwindMerge.twMerge([
        tmp$5,
        "shadow-sm py-2.5 px-3 rounded-md inline-block"
      ])
    });
  } else {
    tmp$4 = null;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        tmp,
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              tmp$2,
              tmp$4,
              JsxRuntime.jsx(ConversationsSection__MessageImages.make, {
                message: message.fragmentRefs
              }),
              JsxRuntime.jsx(ConversationsSection__MessageFiles.make, {
                message: message.fragmentRefs
              }),
              JsxRuntime.jsx("div", {
                children: DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(message.sentAt)), "p"),
                className: TailwindMerge.twMerge([
                  messageIsFromLoggedInUser ? "text-right" : "text-left",
                  "text-sm mt-2 text-gray-500"
                ])
              })
            ]
          }),
          className: "flex flex-col"
        })
      ],
      className: TailwindMerge.twMerge([
        messageIsFromLoggedInUser ? "col-start-5 justify-end" : "",
        "flex flex-row space-x-2 col-span-8 leading-5"
      ])
    }),
    className: "grid grid-cols-12"
  });
}

let make = ConversationPageConversationMessagesMessage;

exports.ChatAvatar = ChatAvatar;
exports.ChatParticipantMenu = ChatParticipantMenu;
exports.MessageFragment = MessageFragment;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Menu Not a pure module */
